import { CloudUpload, PhotoCamera } from '@mui/icons-material';
import { Box, Button, IconButton, Typography, useMediaQuery } from '@mui/material';
import { useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { theme } from '../../../styles/themes/mainTheme';
import { useTranslation } from 'react-i18next';
interface IFormField {
    images: File[];
    setImages: (images: File[]) => void;
}

const MAX_IMAGES = 5;

const ImageUploaderField = ({ images, setImages }: IFormField) => {
    const [error, setError] = useState<string | null>(null);
    const inputFileRef = useRef<HTMLInputElement | null>(null);
    const inputCameraRef = useRef<HTMLInputElement | null>(null);
    const isMobile = useMediaQuery('(max-width:600px)');
    const { t } = useTranslation(['common', 'form']);

    const onImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (images.length >= MAX_IMAGES) {
            setError(t('form:error.imageLimit'));
            return;
        }

        if (event.target.files) {
            const newImages = Array.from(event.target.files);
            const totalFiles = images.length + newImages.length;
            if (totalFiles > MAX_IMAGES) {
                setError(t('form:error.imageLimit'));
                return;
            }

            setError(null);
            setImages([...images, ...newImages]);
        }
    };

    const onRemoveImage = (index: number) => {
        const newImages = images.filter((_, i) => i !== index);
        setImages(newImages);
    };

    return (
        <Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" border="1px dashed #ccc" padding={1}>
                <Box>
                    <input
                        type="file"
                        accept="image/*"
                        multiple
                        style={{ display: 'none' }}
                        onChange={onImageChange}
                        ref={inputFileRef}
                    />
                    <Button onClick={() => inputFileRef.current?.click()}>
                        <CloudUpload /> <Typography variant="body2" fontWeight={"bold"} marginLeft={1}>{t("form:chooseFile")}</Typography>
                    </Button>
                </Box>

                {isMobile && (
                    <Box>
                        <input
                            type="file"
                            accept="image/*"
                            multiple
                            capture="environment"
                            style={{ display: 'none' }}
                            onChange={onImageChange}
                            ref={inputCameraRef}
                        />
                        <IconButton color='primary' onClick={() => inputCameraRef.current?.click()}>
                            <PhotoCamera />
                        </IconButton>
                    </Box>
                )}
            </Box>

            {error && <Typography color="error">{error}</Typography>}

            <Box display="flex" marginTop={2} gap={2} flexWrap={'wrap'} justifyContent={"center"}>
                {images.map((image, index) => (
                    <Box key={index} sx={{ position: "relative" }}>
                        <IconButton onClick={() => onRemoveImage(index)} sx={{
                            position: "absolute",
                            right: 0,
                            top: 0,
                            color: theme.palette.error.main,
                            zIndex: 1,
                            padding: 0
                        }}>
                            <CloseIcon fontSize='small' />
                        </IconButton>
                        <img src={URL.createObjectURL(image)} alt={`Preview ${index}`} style={{ width: '100px', height: '100px' }} />
                    </Box>

                ))}
            </Box>
            <Typography variant="body2" color="textSecondary">{t('form:maxImages')}</Typography>
        </Box>
    );
};

export default ImageUploaderField;
